module.exports = __webpack_public_path__ + "img/amigo-logo.13ba546e.svg";